module.exports = __webpack_public_path__ + "static/5-IMG-4685-50b030953d71e1c408991990e31234f3.jpg";